const ROOT_SELECTOR = "cart-drawer > p[slot='header']";
const RULE_ID_TO_POPUP_REWARD_TITLE_MAP = {
    16137: "Du kan vælge en gratis gave!",
    15500: "Du kan vælge en gratis vareprøve!",
    16748: "Du kan vælge en gratis vareprøve!",
};
const POPUP_REWARD_BUTTON_TEXT = "Vælg gave";
const POPUP_REWARD_STYLE = `
    .popup-reward {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        padding: 12px 1.25rem;
        border-bottom: 1px solid rgb(224, 227, 230);
        background-color : #FBF1F2;
        margin : 0 -1.25rem;
    }
    .popup-reward p.popup-reward__title {
        font-size: 13px;
        font-weight: 600;
        color: #303030;
        display : flex;
    }
    .popup-reward button.popup-reward__button {
        background: #324158;
        color: #fff;
        border-radius: 6px;
        width: 40%;
        max-width: 120px;
        font-size: 14px;
    }
    .popup-reward__image {
        width: 1.25rem;
        height: 1.25rem;
        margin-right: 0.5rem;
        vertical-align: middle;
    }
    @media screen and (min-width: 1000px) {
        .popup-reward {
            padding: 12px 2rem;
            margin : 0  -2rem;
        }
}
`;

const handleOpenPopup = async (ruleId) => {
    console.log(`🔄 Opening modal no.${ruleId}...`);

    const { eligibleOtherRules } = await window.tlFreeGiftOffer.checkAllRule();
    const ruleData = eligibleOtherRules.find(({ rule }) => rule.id === ruleId);

    if (!ruleData) {
        console.warn(`❌ Rule with ID ${ruleId} not found or not eligible.`);
        return;
    }

    const { rule, canClaimCount } = ruleData;
    window.tlFreeGiftOffer.popupWidget.showOffer({rule, canClaimCount});
};

const renderPopupRewards = () => {
    console.log("🔄 Rendering popup rewards...");

    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) {
        console.log("❌ Root element not found:", ROOT_SELECTOR);
        return;
    }

    let container = document.getElementById("popup-rewards-container");

    if (!container) {
        container = document.createElement("div");
        container.id = "popup-rewards-container";
        root.insertAdjacentElement("afterend", container);
    } else {
        container.replaceChildren();
    }

    let style = document.getElementById("popup-rewards-style");
    if (!style) {
        style = document.createElement("style");
        style.id = "popup-rewards-style";
        document.head.appendChild(style);
    }
    style.textContent = POPUP_REWARD_STYLE;

    const { ruleIdMapState, ruleIdMapData, constants } = window.tlFreeGiftOffer;

    const claimableRuleIds = [...ruleIdMapState.entries()]
        .filter(
            ([ruleId, state]) =>
                state.conditionState === constants.CONDITION_STATE.MET_BEFORE_CLAIM && ruleIdMapData.get(ruleId)?.auto_add_gift === false,
        )
        .map(([ruleId]) => ruleId);

    const giftIcon = window.tlCartGoalEmbed?.giftSVG || "";

    claimableRuleIds.forEach((ruleId) => {
        const popupId = `popup-reward-${ruleId}`;
        if (document.getElementById(popupId)) return;

        const popup = document.createElement("div");
        popup.id = popupId;
        popup.className = "popup-reward";

        const title = document.createElement("p");
        title.className = "popup-reward__title";

        const img = document.createElement("img");
        img.className = "popup-reward__image";
        img.src = giftIcon;
        img.alt = "Gift";

        title.appendChild(img);
        title.append(RULE_ID_TO_POPUP_REWARD_TITLE_MAP[ruleId] || "Du kan vælge en gratis gave!");

        const btn = document.createElement("button");
        btn.className = "popup-reward__button";
        btn.textContent = POPUP_REWARD_BUTTON_TEXT;
        btn.addEventListener("click", () => handleOpenPopup(ruleId));

        popup.append(title, btn);
        container.appendChild(popup);
    });

    console.log("✅ Rendering popup rewards done!");
};

// function reRenderPopupWidget(showTrademark) {
//     try {
//         const body = document.querySelector('#cart-drawer');
//         if (!body) console.log("❌ #cart-drawer element not found");
//         else {
            
//         }

//         body.appendChild(window.tlFreeGiftOffer.popupWidget.initialPopupIconElement());
//         document.querySelector('.salepify-fg-advanced-wrapper')?.remove();
//         body.appendChild(window.tlFreeGiftOffer.popupWidget.initialPopupModalElement(showTrademark));

//         window.tlFreeGiftOffer.popupWidget.setModalElement();

//         renderPopupRewards();

//         console.log("✅reRenderPopupWidget run done" );
//     } catch (error) {
//         console.log("Popup widget - Error when initialElement: ", error);
//     }
// }

const intervalId = setInterval(() => {
    if (window.location.pathname === "/cart") {
        clearInterval(intervalId);
        return;
    }

    const offer = window.tlFreeGiftOffer;
    if (!offer?.popupWidget) return;
    
    clearInterval(intervalId);

    console.log("🔄 Customizing popup...");

    const originalShow = offer.showPopupOffer;
    offer.showPopupOffer = async function (...args) {
        const { layout } = offer.popupWidget;
        const { GIFTS_ONLY } = offer.constants.POPUP_LAYOUT;

        if (layout === GIFTS_ONLY) return;
        return originalShow.apply(this, args);
    };

    document.addEventListener("cart-drawer:refreshed", renderPopupRewards);
    window.addEventListener("load", renderPopupRewards);
    console.log("✅ Customizing popup done!");

}, 50);

setTimeout(() => clearInterval(intervalId), 5000);
